<template>
  <section class="card has-border-light is-radius-large m-t-10">
    <div class="card-content p-2 has-text-weight-medium" :style="styles">
      <div class="is-flex is-align-items-center is-justify-content-space-between">
        <p class="m-l-5">{{ label }}</p>
        <TimeEntryButton
          :query-params="queryParams"
          :type="type"
          :sub-type="subType"
          :initial-date="initialDate"
          :week-dates="weekDates"
          :is-read-only="isReadOnly"
          :disabled="disabled"
        />
      </div>
    </div>
  </section>
</template>

<script>
import TimeEntryButton from '@/modules/timeentry/components/stateful/TimeEntryButton.vue';
import { HasAuthUserMixin } from '@/modules/core/app/mixins/HasAuthUserMixin';
import { UrlQueryOperator } from '@/modules/core/app/constants/UrlQueryOperator';
import { canonicalEndDay, canonicalStartDay } from '@/modules/core/app/helpers/DateHelper';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'GenericTimeEntryCard',
  mixins: [HasAuthUserMixin],
  components: { TimeEntryButton },
  props: {
    label: {
      type: String,
      required: true
    },
    color: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    subType: {
      type: String,
      default: null
    },
    initialDate: {
      type: Date
    },
    weekDates: {
      type: Array,
      default: () => []
    },
    isReadOnly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    queryParams() {
      let params = { id: this.authUser.id, type: this.type };
      if (this.subType) {
        params.subType = this.subType;
      }

      params.startedAt = UrlQueryOperator.buildQueryParam(
        UrlQueryOperator.BETWEEN.key,
        canonicalStartDay(this.weekDates[0]),
        canonicalEndDay(this.weekDates.at(-1))
      );
      return params;
    },
    styles() {
      return {
        'border-left': `4px solid ${this.color} !important`,
        'border-top-left-radius': '5px !important',
        'border-bottom-left-radius': '5px !important'
      };
    }
  }
};
</script>
